import { render, staticRenderFns } from "./replyComment.vue?vue&type=template&id=de88a628&scoped=true"
import script from "./replyComment.vue?vue&type=script&lang=ts"
export * from "./replyComment.vue?vue&type=script&lang=ts"
import style0 from "./replyComment.vue?vue&type=style&index=0&id=de88a628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de88a628",
  null
  
)

export default component.exports